import Service from "../Service";

const resource = "frzconditioningrole/";

export default {
    save(prd, requestID) {
        return Service.post(resource + "save", prd, {
            params: { requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    List(parameters, requestID) {
        return Service.post(resource + "List", parameters, {
            params: { requestID: requestID },
        });
    },
    

}; 